import S from './DriversDistanceWidgetStyles';
import EntityRating from '../common/EntityRating/EntityRating';
import { queryFilterByGroups, queryFilters } from '../../utils/queryFilters';
import { resolveFreshQueryResults } from '../../utils/resolveFreshQueryResults';
import GlobalSpinner from '../common/GlobalSpinner/GlobalSpinner';
import useGetDrivers from '../../API/hooks/drivers/useGetDrivers';
import { TimePeriod } from '../../constants/TimePeriod';

type Props = {
  fleetId: string;
  period: string;
  groupFilters?: Record<string, any>;
};

type DistanceField = 'distanceInKmDaily' | 'distanceInKmWeekly' | 'distanceInKmMonthly' | 'distanceInKmTotal';

const PERIOD_TO_DISTANCE_FIELD: Record<string, DistanceField> = {
  daily: 'distanceInKmDaily',
  weekly: 'distanceInKmWeekly',
  monthly: 'distanceInKmMonthly',
};

function DriversDistanceWidget({
  fleetId, period = 'monthly', groupFilters,
}: Props): JSX.Element {
  const distanceField: DistanceField = PERIOD_TO_DISTANCE_FIELD[period] ?? 'distanceInKmTotal';
  const periodLabel = (TimePeriod as any)[period] ?? TimePeriod.all;

  const {
    data: topDrivers,
    isLoading: isTopLoading,
    isPreviousData: isTopPreviousData,
  } = useGetDrivers(fleetId, queryFilters({
    sortBy: [`${distanceField}_DESC`],
  }, 1, `${queryFilterByGroups(groupFilters)}`, '', 3));
  const {
    data: lowDrivers,
    isLoading: isLowLoading,
    isPreviousData: isLowPreviousData,
  } = useGetDrivers(fleetId, queryFilters({
    sortBy: [`${distanceField}_ASC`],
  }, 1, `${queryFilterByGroups(groupFilters)}`, '', 3));

  if (isTopLoading && isLowLoading) {
    return (
      <S.Wrapper>
        <GlobalSpinner />
      </S.Wrapper>
    );
  }

  return (
    <S.Wrapper>
      <EntityRating
        title={`Top driver km • ${periodLabel}`}
        entities={period === 'custom' ? [] : resolveFreshQueryResults(topDrivers, isTopPreviousData)}
        ratingField={distanceField}
        entityType="driver"
        isLoading={isTopLoading}
        emptyMessage={period === 'custom' ? 'No data available for custom period' : undefined}
      />
      <div className="horizont-line" />
      <EntityRating
        title={`Lowest driver km • ${periodLabel}`}
        entities={period === 'custom' ? [] : resolveFreshQueryResults(lowDrivers, isLowPreviousData)}
        ratingField={distanceField}
        entityType="driver"
        isLoading={isLowLoading}
        emptyMessage={period === 'custom' ? 'No data available for custom period' : undefined}
      />
    </S.Wrapper>
  );
}

export default DriversDistanceWidget;
